export default __webpack_public_path__ + "static/media/G_Grass.bd25f3df.jpeg";